export const formatAddress = (address: string, firstPartCharactersAmount = 6, lastPartCharactersAmount = 4) =>
  `${address.slice(0, firstPartCharactersAmount)}...${address.slice(-lastPartCharactersAmount)}`;